module.exports = __webpack_public_path__ + "media/images/flags/64/Cameroon-751cf51811c9a7ba1392065d2f21c742.png";